import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formLabelsTheme,
  iconError,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import {
  makeStyles,
  fade,
  styled,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FilledInput from "@material-ui/core/FilledInput";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  addUpload,
  editBusinessGroup,
  fetchBusinessGroup,
  removeImage,
  selectBusinessGroup,
  selectLoading,
} from "./businessGroupSlice";
import { Autocomplete } from "@material-ui/lab";
import { DropzoneArea } from "material-ui-dropzone";
import { selectMe } from "../../modules/Auth";
import { selectCountryAll } from "../location/locationSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  "& .MuiFilledInput-root": {
    background: "none",
  },
  "& .MuiInputLabel-root": {
    background: "none",
  },
  "& .MuiInputBase-input": {
    background: "none",
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const BasicInformationTab = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataCountry = useSelector(selectCountryAll);
  const data = useSelector(selectBusinessGroup);
  const dataParam2 = useSelector(selectParameter2);

  const dataMe = useSelector(selectMe);

  const [customer_name, setCustomer_name] = useState("");
  const [website, setWebsite] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [country_id, setCountry_id] = useState("");
  const [province, setProvince] = useState("");
  const [co_branding, setCo_branding] = useState("");
  const [culture, setCulture] = useState("");
  const [time_zone, setTime_zone] = useState("");
  const [date_format, setDate_format] = useState("");
  const [pagination, setPagination] = useState("");
  const [cp_first_name, setCp_first_name] = useState("");
  const [cp_last_name, setCp_last_name] = useState("");
  const [cp_email, setCp_email] = useState("");
  const [contactpersons, setContactpersons] = useState([]);
  const [file, setFile] = useState("");

  // tabs
  const types = ["General Information", "Co-Branding"];
  const [active, setActive] = useState(types[0]);

  useEffect(() => {
    if (data !== null) {
      // setCustomer_name(data.customer_name);
      setWebsite(data.website);
      // setAddress1(data.address1);
      setAddress2(data.address2);
      setCity(data.city);
      setZipcode(data.zipcode);
      setProvince(data.province);
      setCountry_id(data.country_id);
      setCo_branding(data.co_branding);
      setCulture(data.culture);
      setTime_zone(data.time_zone);
      setDate_format(data.date_format);
      setPagination(data.pagination);

      setCp_first_name(data.first_name);
      setCp_last_name(data.last_name);
      setCp_email(data.email);

      setFormValues({
        customer_name: {
          value: data.customer_name,
          error: false,
          required: "Y",
        },
        address1: {
          value: data.address1,
          error: false,
          required: "Y",
        },
      });
      const initData =
        data.contactpersons === null
          ? fields
          : data.contactpersons.map((item, index) => {
              return {
                cp_id: item.cp_id,
                emp_id: item.emp_id,
                phone_type: item.phone_type,
                phone: item.phone,
              };
            });

      setFields(initData);
    }
  }, [data]);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(fetchBusinessGroup());

      await dispatch(
        fetchParameter({
          paramgroup_code: "COUNTRY",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "PHONETYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    customer_name: {
      value: "",
      error: false,
      required: "Y",
    },
    address1: {
      value: "",
      error: false,
      required: "Y",
    },
    // website: {
    //   value: "",
    //   error: false,
    //   required: "Y",
    // },
    // first_name: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // last_name: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },

    // address2: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // city: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // zipcode: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // country_id: {
    //   value: "ID",
    //   error: false,
    //   required: "Y",
    // },
    // province: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // email: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // first_name: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
    // last_name: {
    //   value: "",
    //   error: false,
    //   required: "N",
    // },
  });

  const typePhone = dataParam2.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const [fields, setFields] = useState([
    {
      cp_id: "",
      emp_id: "",
      phone_type: "",
      phone: "",
    },
  ]);

  function handlePhoneChange(i, event) {
    const values = [...fields];
    values[i].phone = event.target.value;
    setFields(values);
  }

  function handleAdd() {
    const values = [...fields];
    values.push({
      cp_id: "",
      emp_id: "",
      phone_type: "",
      phone: "",
    });
    setFields(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].phone_type = event.value;
    setFields(values);
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleCountry = (e) => {
    if (e === null) {
      e = undefined;
      setCountry_id("");
    } else {
      setCountry_id(e.target.value);
    }
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (
      formValues.customer_name.value.includes("<script>") ||
      formValues.customer_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }
    if (
      formValues.address1.value.includes("<script>") ||
      formValues.address1.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (!validatePost()) {
      return;
    }
    const params = {
      id: data.id,
      customer_name: formValues.customer_name.value,
      website: website,
      address1: formValues.address1.value,
      address2: address2,
      zipcode: zipcode,
      country_id: country_id,
      province: province,
      co_branding: co_branding,
      city: city,
      first_name: cp_first_name,
      last_name: cp_last_name,
      email: cp_email,
      contactpersons: fields,
    };
    console.log(params, "params");
    try {
      const response = await dispatch(editBusinessGroup(params));
      console.log(response, "responsse");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const index = countryOptions.findIndex((obj) => obj.value === country_id);

  const handleUpload = async () => {
    if (file === undefined) {
      return showErrorDialog("Field can't be empty");
    }

    const params = {
      id: data.office_id,
      file: file,
    };

    try {
      const response = await dispatch(addUpload(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchBusinessGroup());
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleDeleteImage = async () => {
    const params = {
      id: data.id,
    };
    try {
      const response = await dispatch(removeImage(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchBusinessGroup());
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          <ButtonToolbar>
            {types.map((type) => (
              <Button
                active={active === type}
                onClick={() => setActive(type)}
                variant="outline-primary"
                className="m-2 "
              >
                {type}
              </Button>
            ))}
          </ButtonToolbar>
          <ThemeProvider theme={formLabelsTheme}>
            <>
              {active === "General Information" && (
                <CardBody>
                  <div>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Company Name"
                          className={classes.margin}
                          //
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="customer_name"
                          value={formValues.customer_name.value}
                          onChange={handleChange}
                          error={formValues.customer_name.error}
                          helperText={
                            formValues.customer_name.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          required
                          label="Addres Line 1"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          multiline
                          rows="4"
                          fullWidth
                          name="address1"
                          value={formValues.address1.value}
                          onChange={handleChange}
                          error={formValues.address1.error}
                          helperText={
                            formValues.address1.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          label="City"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setCity(e.target.value);
                          }}
                          value={city}
                        />
                        <Autocomplete
                          disablePortal
                          variant="filled"
                          options={countryOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={(e, value) => setCountry_id(value.value)}
                          value={countryOptions[index]}
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Country"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Country *"
                            />
                          )}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {" "}
                        <RedditTextField
                          label="Website URL"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setWebsite(e.target.value);
                          }}
                          value={website}
                        />
                        <RedditTextField
                          label="Address Line 2"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          onChange={(e) => {
                            setAddress2(e.target.value);
                          }}
                          value={address2}
                        />
                        <RedditTextField
                          label="Zip Code"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setZipcode(e.target.value);
                          }}
                          value={zipcode}
                        />
                        <RedditTextField
                          label="Province"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setProvince(e.target.value);
                          }}
                          value={province}
                        />
                      </Col>
                    </Row>
                    <p className="font-weight-bold  m-3">Contact Person :</p>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="First Name"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setCp_first_name(e.target.value);
                          }}
                          value={cp_first_name}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="Last Name"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setCp_last_name(e.target.value);
                          }}
                          value={cp_last_name}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {fields.map((field, idx) => {
                          return (
                            <div key={`${field}-${idx}`}>
                              <Row>
                                <Col md={4}>
                                  <Select
                                    // isClearable={true}
                                    options={typePhone}
                                    value={getValueType(
                                      field.phone_type,
                                      typePhone
                                    )}
                                    placeholder="Select Type"
                                    onChange={(e) => handleTypeChange(idx, e)}
                                    className="mt-4 ml-3"
                                  />
                                </Col>
                                <Col md={6}>
                                  <RedditTextField
                                    label="Phone Number"
                                    type="number"
                                    className={classes.margin}
                                    variant="filled"
                                    id="reddit-input"
                                    size="small"
                                    fullWidth
                                    value={field.phone || ""}
                                    onChange={(e) => handlePhoneChange(idx, e)}
                                  />
                                </Col>
                                {fields.length !== 1 && (
                                  <Col>
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 "
                                      onClick={() => handleRemove(idx)}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/New/X.svg"
                                          )}
                                        />
                                      </span>
                                    </div>
                                  </Col>
                                )}
                                <Col sm={1}>
                                  {fields.length - 1 === idx && (
                                    <Button
                                      variant="outline-primary"
                                      onClick={(e) => handleAdd()}
                                      className="mt-4 "
                                    >
                                      Add
                                    </Button>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                      </Col>

                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="Email"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          onChange={(e) => {
                            setCp_email(e.target.value);
                          }}
                          value={cp_email}
                        />
                      </Col>
                    </Row>
                  </div>
                  <Row className="mt-6 justify-content-end">
                    <Button variant="primary" onClick={handleSave}>
                      Save
                    </Button>
                  </Row>
                </CardBody>
              )}
              {active === "Co-Branding" && (
                <CardBody>
                  <>
                    <DropzoneArea
                      acceptedFiles={["image/*"]}
                      dropzoneText={"Drag and drop an image here or click"}
                      onChange={(files) => setFile(files[0])}
                    />

                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleUpload}>
                        Save
                      </Button>
                    </Row>
                    {data.co_branding !== null && (
                      <Row>
                        <div>
                          <h3 className="mb-5 mr-5">
                            Last Image Upload : {data.co_branding}
                          </h3>
                          <div
                            className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 mr-4    "
                            onClick={() => {
                              window
                                .open(data.co_branding_url, "_blank")
                                .focus();
                            }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-light">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Design/Image.svg"
                                )}
                              />
                            </span>
                          </div>
                          <div
                            className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 mr-4  "
                            onClick={handleDeleteImage}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-light">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/New/delete.svg"
                                )}
                              />
                            </span>
                          </div>
                        </div>{" "}
                      </Row>
                    )}
                  </>
                </CardBody>
              )}
            </>
          </ThemeProvider>
        </CardBody>
      </Card>
    </>
  );
};
